import React, { useContext, useState } from 'react'
import { Button, CircularProgress } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { UserContext } from '../../context'
import { requestMentorship } from '../../services/Mentorship'
import ConfirmationDialog from './ConfirmationDialog'
import ProfileCompletionAlert from '../../components/works/ProfileCompletionAlert'

const BecomeMentor = ({ isSidebar }) => {
    const navigate = useNavigate()
    const { user, setUser } = useContext(UserContext)
    const [isLoading, setIsLoading] = useState(false)
    const [isConfirmationOpen, setIsConfirmationOpen] = useState(false)
    const [messages, setMessages] = useState('')
    const [error, setError] = useState('')
    const [isProfileComplete, setIsProfileComplete] = useState(true)

    const [openAlert, setOpenAlert] = useState(false);
    const [title, setTitle] = useState("");
    const [message, setMessage] = useState("");
    const [buttonText, setButtonText] = useState("");
    const [onButtonClick, setOnButtonClick] = useState(() => () => { });

    const handleCloseDialog = () => {
        setIsConfirmationOpen(false)
        setMessages('')
        setError('')
        setIsProfileComplete(true)
        setIsLoading(false);
    }

    const handleBecomeMentor = () => {
        if (!user) {
            console.log('Mentor')
            setButtonText("Sign Required");
            setMessage("You need to be signed in to request mentorship.");
            setButtonText("Sign In");
            setOnButtonClick(() => () => {
                setOpenAlert(false);
                navigate('/signin');
            });
            setOpenAlert(true);
            return;
        }
        setIsLoading(true);
        requestMentorship({ user_id: user.id })
            .then((response) => {
                console.log('Request mentorship response', response)
                setUser(prev => ({
                    ...prev,
                    mentorship_requested: true
                }));
                setMessages(response.message)
                setIsProfileComplete(
                    response?.is_profile_completed ?? true
                )
                setIsConfirmationOpen(true)
                setIsLoading(false)
            })
            .catch((error) => {
                console.error('Error requesting mentorship', error)
                setError(error.error)
                setIsProfileComplete(
                    error?.is_profile_completed ?? false
                )
                setIsConfirmationOpen(true)
                setIsLoading(false)
            })
    }

    return (
        <React.Fragment>
            <Button
                onClick={handleBecomeMentor}
                variant="contained"
                color="primary"
                disableElevation
                fullWidth={isSidebar}
                disabled={user?.is_mentor || isLoading || user?.mentorship_requested}
                sx={{
                    borderRadius: "50px",
                    display: user?.is_mentor ? 'none' : 'flex',
                    textTransform: "none",
                    "&:hover": {
                        transform: "translateY(-2px)",
                        transition: "all 0.3s ease",
                    },
                }}
                startIcon={isLoading ? <CircularProgress size={20} /> : null}
            >
                {user?.mentorship_requested ? "Request Sent" : "Become a Mentor"}
            </Button>

            <ConfirmationDialog
                open={isConfirmationOpen}
                onClose={handleCloseDialog}
                message={messages}
                isProfileComplete={isProfileComplete}
                error={error}
            />

            <ProfileCompletionAlert
                openAlert={openAlert}
                onCloseAlert={() => setOpenAlert(false)}
                title={title}
                message={message}
                buttonText={buttonText}
                onButtonClick={onButtonClick}
            />

        </React.Fragment>
    )
}

export default BecomeMentor
